<template>
  <div class="languages-page">
    <languages-table
      :rows="composable.rows.value"
      :loading="composable.loading.value"
      @add-language="openModal"
      @refresh="loadData"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import { useLanguagesAdmin } from '../../composables/useLanguagesAdmin';

const composable = useLanguagesAdmin();

const loadData = async (): Promise<void> => {
  log('LanguagesPage', 'loadData', 'Loading');
  try {
    await composable.fetchAll();
  } catch (err) {
    log('LanguagesPage', 'loadData', 'Error', err);
  }
};

const openModal = (): void => {
  log('LanguagesPage', 'openModal', 'Opening add language modal');
  eventBus.emit('modal.languagesAdmin.open');
};

onMounted(async () => {
  await loadData();
  eventBus.on('languagesAdmin.created', loadData);
});

onBeforeUnmount(() => {
  eventBus.off('languagesAdmin.created', loadData);
});
</script>

<style scoped>
.languages-page {
  padding: 20px;
}
</style>
